"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CopyAccountState = CopyAccountState;
exports.BuildResponse = BuildResponse;
var response_1 = require("@ca/wrap-sdk/src/response");
var token_1 = require("../token");
var sprintf_js_1 = require("sprintf-js");
var aws_dynamo_1 = require("@ca/wrap-sdk/src/aws-dynamo");
var item_io_1 = require("../item-io");
var js_utils_1 = require("@ca/wrap-sdk/src/js-utils");
function CopyAccountState(account_state_raw) {
    var result = {};
    if (account_state_raw) {
        var states = JSON.parse(account_state_raw);
        for (var i = 0; i < states.length; i++) {
            result[(0, sprintf_js_1.sprintf)("%04d", i)] = states[i];
        }
    }
    return result;
}
function LabelMatch(item, label) {
    var re = /^([^_]+)_(\d{4})$/;
    var match = item.id.match(re);
    if (!match) {
        return { match: false };
    }
    if (match[1] === label) {
        return {
            match: true,
            key: match[2],
        };
    }
    return { match: false };
}
function BuildResponse(id_creds, curr_resp) {
    return __awaiter(this, void 0, void 0, function () {
        var d_resp, decoded, identity_id, wlf_id, response, keys, num_states, i, b_resp, labels, i, item, j, label, match, array;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    d_resp = (0, token_1.DecodeToken)(curr_resp.token);
                    if (d_resp.status === response_1.Status.ERROR) {
                        return [2 /*return*/, d_resp];
                    }
                    decoded = d_resp.payload;
                    identity_id = decoded['custom:identity-id'];
                    wlf_id = decoded['custom:wlf-id'];
                    response = __assign(__assign({}, curr_resp), { account_type: decoded['custom:account-type'], name: decoded.name, username: decoded['cognito:username'], account_state: CopyAccountState(decoded['custom:account-states']), identity_id: identity_id, confirmed: true, email: { unread_count: 0 }, onboarding: [], tda: [], dwolla: [], loaded_acct_index: 0 });
                    keys = [
                        { partition: identity_id, id: "user" }
                    ];
                    num_states = Object.keys(response.account_state).length;
                    for (i = 0; i < num_states; i++) {
                        keys.push({ partition: identity_id, id: (0, sprintf_js_1.sprintf)("onboarding_%04d", i) });
                        keys.push({ partition: identity_id, id: (0, sprintf_js_1.sprintf)("tda_%04d", i) });
                        keys.push({ partition: identity_id, id: (0, sprintf_js_1.sprintf)("dwolla_%04d", i) });
                    }
                    return [4 /*yield*/, (0, aws_dynamo_1.BatchC)(id_creds, (0, item_io_1.GetWlfTable)(wlf_id), keys)];
                case 1:
                    b_resp = _a.sent();
                    if (b_resp.status === response_1.Status.ERROR) {
                        return [2 /*return*/, (0, response_1.ErrorResponse)(b_resp)];
                    }
                    labels = ["onboarding", "tda", "dwolla"];
                    for (i = 0; i < b_resp.payload.length; i++) {
                        item = b_resp.payload[i];
                        item.acct_index = parseInt(item.id.split("_").pop(), 10);
                        for (j = 0; j < labels.length; j++) {
                            label = labels[j];
                            match = LabelMatch(item, label);
                            if (match.match) {
                                array = response[label];
                                array.push(item);
                            }
                        }
                        response.onboarding.sort(function (a, b) { return (0, js_utils_1.string_cmp)(a.id, b.id); });
                        response.tda.sort(function (a, b) { return (0, js_utils_1.string_cmp)(a.id, b.id); });
                        response.dwolla.sort(function (a, b) { return (0, js_utils_1.string_cmp)(a.id, b.id); });
                        if (item.id === "user") {
                            response.loaded_acct_index = item.loaded_acct_index;
                        }
                    }
                    return [2 /*return*/, (0, response_1.SuccessResponse)(response)];
            }
        });
    });
}
//# sourceMappingURL=response.js.map